import './globals'; // Adjust if needed
import React, { Component } from "react";
import screenfull from "screenfull";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);

    const numberOfDivs = this.getRandomInt(42, 42);
    // console.log(
    //   "♻️ RECYCLED INTERNETS ♻️",
    //   numberOfDivs,
    //   "recycled images"
    // );
    const selectedImages =[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

    this.state = {
      divs: this.initializeDivs(numberOfDivs, selectedImages),
      selectedImages,
    };

    this.updateIntervals = {};
    this.scaleIntervals = {};
  }

  componentDidMount() {
    // Dynamically inject keyframes for explosion animation
    this.injectKeyframes();

    // Start the update timers:
    this.startUpdates();
    this.startScaleUpdates();
  }

  componentWillUnmount() {
    Object.values(this.updateIntervals).forEach(clearTimeout);
    Object.values(this.scaleIntervals).forEach(clearTimeout);
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  getRandomScale() {
    return Math.random() * (1.4 - 0.2) + 0.2;
  }

  initializeDivs(count, images) {
    return Array.from({ length: count }, () => ({
      currentImage: images[this.getRandomInt(0, images.length)],
      scale: this.getRandomScale(),
      position: this.getRandomPosition(),
    }));
  }

  getRandomPosition() {
    return {
      top: `${this.getRandomInt(-20, 120)}%`,
      left: `${this.getRandomInt(-20, 120)}%`,
    };
  }

  startUpdates() {
    this.state.divs.forEach((_, index) => {
      const updateDiv = () => {
        this.setState((prevState) => {
          const newDivs = [...prevState.divs];
          newDivs[index] = {
            ...newDivs[index], 
            currentImage:
              prevState.selectedImages[
                this.getRandomInt(0, prevState.selectedImages.length)
              ],
            position: this.getRandomPosition(),
          };
          return { divs: newDivs };
        });
        this.updateIntervals[index] = setTimeout(
          updateDiv,
          this.getRandomInt(200, 5000)
        );
      };
      this.updateIntervals[index] = setTimeout(
        updateDiv,
        this.getRandomInt(200, 5000)
      );
    });
  }

  startScaleUpdates() {
    this.state.divs.forEach((_, index) => {
      const updateScale = () => {
        this.setState((prevState) => {
          const newDivs = [...prevState.divs];
          newDivs[index] = {
            ...newDivs[index],
            scale: this.getRandomScale(),
          };
          return { divs: newDivs };
        });
        this.scaleIntervals[index] = setTimeout(updateScale, this.getRandomInt(500, 2000));
      };
      this.scaleIntervals[index] = setTimeout(updateScale, this.getRandomInt(500, 2000));
    });
  }

  injectKeyframes() {
    const keyframes = `
      @keyframes explosion {
        0% {
          background: radial-gradient(circle, rgba(255, 0, 0, 1) 20%, rgba(255, 165, 0, 1) 40%, rgba(255, 105, 0, 1) 60%, rgba(255, 140, 0, 1) 100%);
        }
        50% {
          background: radial-gradient(circle, rgba(255, 0, 0, 0.8) 25%, rgba(255, 140, 0, 0.8) 50%, rgba(255, 105, 0, 0.8) 70%, rgba(255, 165, 0, 1) 100%);
        }
        100% {
          background: radial-gradient(circle, rgba(255, 0, 0, 0) 100%, rgba(255, 165, 0, 0) 100%, rgba(255, 140, 0, 0) 100%, rgba(255, 105, 0, 0) 100%);
        }
      }
    `;
    
    const styleSheet = document.createElement("style");
    styleSheet.innerText = keyframes;
    document.head.appendChild(styleSheet);
  }

  goFullScreen = () => {
    const element = document.querySelector(".App");
    if (screenfull.isEnabled && element) {
      screenfull.request(element);
    }
  };

  render() {
    return (
      <div
        className="App"
        style={{
          // Apply explosion animation with red and orange shades
          background: "radial-gradient(circle at center, rgba(255, 0, 0), rgba(255, 170, 0), rgba(255, 60, 0))",
          backgroundSize: "700% 700%",
          animation: "explosion 1s ease-out infinite",  // Applying explosion animation
        }}
      >
        {this.state.divs.map((div, index) => (
          <div
            className="theArt"
            key={index}
            onClick={() => this.goFullScreen()}
            style={{
              position: "absolute",
              top: div.position.top,
              left: div.position.left,
              transform: `translate(-50%, -50%) scale(${div.scale})`,
            }}
          >
            <img src={require(`./images/${div.currentImage}.gif`)} alt={`art${index + 1}`} />
          </div>
        ))}
        <canvas id="captureCanvas" style={{ display: "none" }}></canvas>
      </div>
    );
  }
}

export default App;
